import React from 'react';
import MyAccountOrderDetailsSupport from '../MyAccountOrderDetailsSupport/MyAccountOrderDetailsSupport';

interface CarePlusSupportProps {
  language: string;
  country: string;
}

const CarePlusSupport: React.FC<CarePlusSupportProps> = ({ language, country }) => (
  <div className="careplus-order-detail__section">
    <MyAccountOrderDetailsSupport language={language} country={country} isProbatixOrder={false} />
  </div>
);

export default CarePlusSupport;
